import { Typography } from '@mui/material'
import { JobDto, WorkInstructionWarningReason } from '@operations/app/api'
import { useOperationsStore } from '@operations/AppProvider'
import { useTranslate } from '@tolgee/react'
import { ReactNode } from 'react'
import { JobAlert } from '../JobCard/JobAlert'
import { JobDescription } from '../JobCard/JobDescription'
import { StepperContentWrapper } from '../Stepper/StepperContentWrapper'

interface Props {
  job: JobDto
  jobWarningReason?: WorkInstructionWarningReason
  currentStep?: number
  stepsTotal?: number
  children: ReactNode
}
export const JobInformationWrapper = ({
  job,
  currentStep,
  stepsTotal,
  children,
  jobWarningReason,
}: Props) => {
  const { t } = useTranslate()
  const { equipmentOperatorUIStore, tenantConfigStore } = useOperationsStore()

  const fieldsToShow = tenantConfigStore.getOperatorFieldsByEquipmentAndOperationTypeAndCarrierType(
    equipmentOperatorUIStore.typeOfSelectedEquipment,
    job.operationType,
    job.carrierVisit?.type,
  )

  return (
    <StepperContentWrapper
      title={t('checkInformation', 'Check information')}
      steps={
        currentStep !== undefined && stepsTotal !== undefined && stepsTotal > 1
          ? `${currentStep} ${t('of', 'of')} ${stepsTotal}`
          : undefined
      }
    >
      <Typography variant='subtitle1'>{t('generalInformation', 'General information')}</Typography>
      <JobDescription job={job} fieldsToShow={fieldsToShow} stepper />
      <JobAlert
        warningReason={jobWarningReason}
        isOnStepper
        entryHoldRestriction={job.entryHoldRestriction}
        exitHoldRestriction={job.exitHoldRestriction}
        yardHoldRestriction={job.yardHoldRestriction}
        operationType={job.operationType}
      />

      {children}
    </StepperContentWrapper>
  )
}
